import React from 'react';
import Grid from '@mui/material/Grid';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import PortfolioBuilderStore, { adStrategies } from '../stores';
import { formatMoney } from 'src/utils/stringFormatting';
import { useAppSelector } from 'src/utils/Hooks';

const Row = ({ leftContent, rightContent }) => {
  return (
    <>
      <Grid
        item
        sx={{
          height: '32px',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Text
          variant="body2"
          sx={{
            fontWeight: 'bold',
            lineHeight: '20px'
          }}
        >
          {leftContent}
        </Text>
      </Grid>
      <Grid
        item
        sx={{
          height: '32px',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Text
          variant="body2"
          sx={{
            lineHeight: '20px',
            marginTop: 'auto',
            marginBottom: 'auto',
            height: 'fit-content',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          {rightContent}
        </Text>
      </Grid>
    </>
  );
};

export const ConfirmationGrid = () => {
  const { selectedCampaignIds, portfolioName, budget, selectedEntityId, selectedOptimizationId } =
    PortfolioBuilderStore((s) => ({
      portfolioName: s.portfolioName,
      budget: s.budget,
      selectedEntityId: s.selectedEntityId,
      selectedOptimizationId: s.selectedOptimizationId,
      selectedCampaignIds: s.selectedCampaignIds
    }));

  const adEntities = useAppSelector((state) => state?.adEntities);
  const currencySymbol = useAppSelector((state) => state?.retailer?.currencySymbol) || '$';
  const selectedAdEntityName = adEntities.find((x: any) => x.settingId === selectedEntityId)?.name;

  return (
    <Grid
      container
      sx={{
        display: 'grid',
        gridTemplateColumns: 'max-content max-content',
        columnGap: 4,
        rowGap: 3,
        width: 'fit-content'
      }}
    >
      <Row leftContent="Portfolio Name:" rightContent={portfolioName} />
      <Row
        leftContent="Total Budget:"
        rightContent={
          <>
            {formatMoney(budget, currencySymbol, 2)}
            <Text
              variant="body3"
              sx={{
                fontWeight: 500
              }}
            >
              This will increase the {selectedAdEntityName} entity budget by {formatMoney(budget, currencySymbol, 2)}.
            </Text>
          </>
        }
      />
      <Row leftContent="Optimization:" rightContent={adStrategies.find((x) => x.id === selectedOptimizationId).label} />
      <Row leftContent="Entity:" rightContent={selectedEntityId} />
      <Row leftContent="Campaigns:" rightContent={selectedCampaignIds.size} />
    </Grid>
  );
};
